var enums = {
  // 消息类型
  actions: {
    // 代表被服务端强制下线
    ACTION_999: '999',
    // 系统通知
    ACTION_0: '0',
    // 消息条数
    ACTION_1: '1',
    // 求职者发送消息到企业
    ACTION_2: '2',
    // 企业发送消息到求职者
    ACTION_3: '3',
    // 接收IM消息提醒条数和和某个id的最后一条聊天记录
    ACTION_4: '4',

  }
}

export {
  enums
}